import { c as _c } from "react/compiler-runtime";
import { useIntersectionToggle } from '@cc-shopping/hooks/useIntersectionToggle';
import { theme } from '@cc-shopping/ui/theme';
import { Stack, useMediaQuery } from '@mui/material';
import { useCallback, useMemo, useRef, useState } from 'react';
import { AppliedFilters } from './components/AppliedFilters';
import { FiltersStatic } from './components/FiltersStatic';
import { FiltersSticky } from './components/FiltersSticky';
import { useDesktopFilterOptions } from './hooks/useDesktopFilterOptions';
function isScrollPastEntry(entry: IntersectionObserverEntry): boolean {
  return !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
}
export function RoundupFiltersDesktop(t0) {
  const $ = _c(23);
  const {
    contentRef
  } = t0;
  const containerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = theme.breakpoints.up("sm");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isDesktopViewport = useMediaQuery(t1);
  const isScrollPastFilters = useIntersectionToggle(containerRef, isScrollPastEntry);
  const [stickyBarHeight, setStickyBarHeight] = useState(0);
  let t2;
  if ($[1] !== stickyBarHeight) {
    t2 = el => {
      if (!el) {
        return;
      }
      const height = el.getBoundingClientRect().height;
      if (height !== stickyBarHeight) {
        setStickyBarHeight(height);
      }
    };
    $[1] = stickyBarHeight;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const stickyBarRefCallback = t2;
  let t3;
  if ($[3] !== stickyBarHeight) {
    t3 = entry => !entry.isIntersecting && entry.boundingClientRect.bottom <= stickyBarHeight;
    $[3] = stickyBarHeight;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const isScrollPastContentEntry = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `-${stickyBarHeight}px 0px 0px 0px`;
  let t6;
  if ($[6] !== t5) {
    t6 = {
      intersectionOptions: {
        threshold: t4,
        rootMargin: t5
      }
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const intersectionOptionsContent = t6;
  const isScrollPastContent = useIntersectionToggle(contentRef, isScrollPastContentEntry, intersectionOptionsContent);
  const showFiltersSticky = isScrollPastFilters && !isScrollPastContent && isDesktopViewport;
  const filterOptions = useDesktopFilterOptions();
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      containerRef.current?.scrollIntoView({
        behavior: "instant"
      });
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleStickyBarChange = t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      display: {
        xs: "none",
        sm: "flex"
      },
      scrollMarginTop: _temp,
      py: 2,
      gap: 3
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== filterOptions || $[11] !== isScrollPastFilters) {
    t9 = <FiltersStatic filterOptions={filterOptions} forceCloseDropdowns={isScrollPastFilters} />;
    $[10] = filterOptions;
    $[11] = isScrollPastFilters;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <AppliedFilters />;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t9) {
    t11 = <Stack direction="column" ref={containerRef} component="div" sx={t8}>{t9}{t10}</Stack>;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== filterOptions || $[17] !== showFiltersSticky || $[18] !== stickyBarRefCallback) {
    t12 = showFiltersSticky && <FiltersSticky filterOptions={filterOptions} ref={stickyBarRefCallback} onChange={handleStickyBarChange} />;
    $[16] = filterOptions;
    $[17] = showFiltersSticky;
    $[18] = stickyBarRefCallback;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}
function _temp(t0) {
  const {
    spacing
  } = t0;
  return spacing(3);
}